import VueRouter, { RouteConfig } from 'vue-router'

const DrillReport = () => import('../views/drill-report/DrillReport.vue')
const DrillReportLayout = () => import('../views/drill-report/DrillReportLayout.vue')
const DrillReportCompetition = () => import('../views/drill-report/DrillReportCompetition.vue')

export const drillReportRoute: RouteConfig = {
  path: '/drill-report',
  name: 'drill_report',
  component: DrillReport,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '训练报告',
  },
}

export const drillReportWithLayoutRoute: RouteConfig = {
  path: '/drill-report-layout',
  name: 'drill_report_layout',
  component: DrillReportLayout,
  children: [
    {
      path: '/drill-report-with-layout',
      name: 'drill_report_with_layout',
      component: DrillReport,
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '训练报告',
      },
    },
  ],
}

export const drillReportCompetitionRoute: RouteConfig = {
  path: '/drill-report-competition',
  name: 'drill_report_competition',
  component: DrillReportCompetition,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '训练报告',
  },
}

const RDrillReport: RouteConfig[] = [drillReportRoute, drillReportWithLayoutRoute, drillReportCompetitionRoute]

export default RDrillReport

export function navigateToDrillReport(router: VueRouter, id: string) {
  router.push({ name: drillReportRoute.name, query: { id } })
}

export function navigateToDrillReportCompetition(
  router: VueRouter,
  id: string, // drill_record_id
  status: boolean, // match_drill_record是否有效，status
  statusId: string, // match_drill_record_id
  userId: string,
  matchId: string,
  aiLabel?: string //如果指定则报告页面显示ai标签从外部读
) {
  router.push({
    name: drillReportCompetitionRoute.name,
    query: { id, status: status ? '0' : '1', statusId, userId, matchId, aiLabel },
  })
}
